import Highcharts from 'highcharts';
import Request from 'request';

export default class Graph {
  build(requests, options) {
    var series = []
    var fetchRequests = requests.map(function(request) {
      let builtRequest = Request.buildRequest(request);
      return fetch(builtRequest)
        .then((response) => {
          return response.json()
        })
        .then((data) => {
         series.push({
            name: request.series_name, 
            data: Graph.formatData(data)})
        })   
    })

    Promise
      .all(fetchRequests)
      .then(() => {
        Graph.buildHighchart(series.sort((a, b) => (a.name > b.name) ? 1 : -1), options);
      })
  }
  
  static formatData(data) {
      var formattedData = [];
      for(var i = 0; i < data.periods.length; i++) {
        formattedData.push([data.periods[i].unix_start_datetime * 1000, data.periods[i].count])
      }
      return formattedData;
  };

  static buildHighchart(series, options) {
    Highcharts.chart('js-record-chart', {
      accessibility: { enabled: false },
      chart: {
        type: options.graph_type,
        backgroundColor: options.background_color,
        style: {
          fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif'
        }
      },
      colors: options.graph_colors,
      title: {
          text: options.graph_title,
          style: {
            color: '#333333'
          }
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          month: '%b %y'
        },
        labels: {
          style: {
            color: '#666666',
            fontSize: '10px'
          }
        }
      },
      yAxis: {
          min: 0,
          gridLineColor: '#e6e6e6',
          title: {
              text: ''
          },
          labels: {
            style: {
              color: '#666666',
              fontSize: '10px'
            }
          }
      },
      tooltip: {
        formatter: function() {
          return '<b>'+ this.series.name +'</b><br/>'+
          Highcharts.dateFormat('%e. %b, %y', this.x) +': '+ this.y;
        }
      },
      plotOptions: {
        area: {
          fillColor: options.graph_area_color,
        }
      },
      credits: {
        enabled: false
      },
      series: series
    });
  }
};
